module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-toolbar', {
    staticClass: "transparent display-1",
    attrs: {
      "flat": ""
    }
  }, [_vm._v("\n        Dešavanja\n      ")]), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_vm._l((_vm.messages), function(message, index) {
    return [_c('v-list-tile', {
      key: message.id,
      on: {
        "click": function($event) {
          _vm.open(message)
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.title(message)))]), _vm._v(" "), _c('v-list-tile-sub-title', {
      staticClass: "text--primary"
    }, [_vm._v(_vm._s(_vm.deliveryInfo(message)))])], 1)], 1), _vm._v(" "), (index + 1 < _vm.messages.length) ? _c('v-divider') : _vm._e()]
  })], 2)], 1)], 1)], 1)
},staticRenderFns: []}